const directives = import.meta.glob('@/directives/**/*.js', { eager: true, import: 'default' });

export default {
  install(app) {
    Object.values(directives).forEach((module) => {
      app.directive(module.name, module);
    });
  },
};
